import { render, staticRenderFns } from "./refinish.vue?vue&type=template&id=bc64f348&scoped=true"
import script from "./refinish.vue?vue&type=script&lang=js"
export * from "./refinish.vue?vue&type=script&lang=js"
import style0 from "./refinish.vue?vue&type=style&index=0&id=bc64f348&prod&lang=css"
import style1 from "./refinish.vue?vue&type=style&index=1&id=bc64f348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc64f348",
  null
  
)

export default component.exports